import { useEffect, useRef } from "react";
import imageTerraza from './../../Images/about-terraza.jpg'
import imageCarlospaz from './../../Images/about-carlospaz.jpg'
import imageKite from './../../Images/about-kite.jpg'
import imageBariloche from './../../Images/about-bariloche.jpg'
import imageWiki from './../../Images/about-wiki.jpg'

import './Slider.css';

export const Slider = () => {

    const track = useRef(null);
    useEffect(() => {
        const handleOnDown = e => {
            if(track.current) {
                track.current.dataset.mouseDownAt = e.clientX;
            }      
        }

        const handleOnUp = () => {
            if(track.current) { 
                track.current.dataset.mouseDownAt = "0";  
                track.current.dataset.prevPercentage = track.current.dataset.percentage;
            }
        }

        const handleOnMove = e => {
            if(!track.current || track.current.dataset.mouseDownAt === "0") return;
            
            const mouseDelta = parseFloat(track.current.dataset.mouseDownAt) - e.clientX,
                    maxDelta = window.innerWidth / 2;
            
            const percentage = (mouseDelta / maxDelta) * -100,
                    nextPercentageUnconstrained = parseFloat(track.current.dataset.prevPercentage) + percentage,
                    nextPercentage = Math.max(Math.min(nextPercentageUnconstrained, 0), -51);
            
            track.current.dataset.percentage = nextPercentage;
            
            track.current.animate({
                transform: `translate(${nextPercentage}%, -50%)`
            }, { duration: 1200, fill: "forwards" });
            
            for(const image of track.current.getElementsByClassName("image")) {
                image.animate({
                objectPosition: `${100 + nextPercentage*2}% center`
                }, { duration: 1200, fill: "forwards" });
            }
        }

        /* -- Had to add extra lines for touch events -- */

        window.onmousedown = e => handleOnDown(e);

        window.ontouchstart = e => handleOnDown(e.touches[0]);

        window.onmouseup = e => handleOnUp(e);

        window.ontouchend = e => handleOnUp(e.touches[0]);

        window.onmousemove = e => handleOnMove(e);

        window.ontouchmove = e => handleOnMove(e.touches[0]);
    }, [])

    return(
        <div className="body-slider">
            <div id="image-track" ref={track} class="px-3 px-lg-4" data-mouse-down-at="0" data-prev-percentage="0">
                <img class="image" src={imageTerraza} draggable="false" />
                <img class="image" src={imageCarlospaz} draggable="false" />
                <img class="image" src={imageKite} draggable="false" />
                <img class="image" src={imageBariloche} draggable="false" />
                <img class="image" src={imageWiki} draggable="false" />   
                <img class="image hidden-image" src={imageWiki} draggable="false" />   
                <img class="image hidden-image" src={imageWiki} draggable="false" />   
                <img class="image hidden-image" src={imageWiki} draggable="false" />   
            </div>
        </div>
    )
}